/* eslint-disable no-nested-ternary */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  backDropMessage: {
    paddingLeft: "1em",
  },
}));
//global overlay component applied when an API call is in progress.
const BackDropOverlay = () => {
  const classes = useStyles();
  //only when API call flag is true, default value is always false
  const backDropState = useSelector((state) => state.ui.backDrop);
  return (
    <div>
      {" "}
      <Backdrop className={classes.backdrop} open={backDropState.open}>
        <CircularProgress color="inherit" />
        <span className={classes.backDropMessage}>{backDropState.message}</span>
      </Backdrop>
    </div>
  );
};

export default BackDropOverlay;
